import { motion } from "framer-motion";

import { Section, SectionHead } from "../components/ui";
import { DIFFERENTIATORS } from "../data/capabilities";

/**
 * Why us — as a divided grid rather than six more glass cards.
 *
 * Six cards in a row is the visual signature of a services site, and this
 * is the section where a reader is most alert to filler. Hairline cells
 * read as a specification table: dense, factual, unbothered about
 * impressing anyone. The claims carry the weight instead of the container.
 */
export function Differentiators() {
  return (
    <Section id="why">
      <div className="container">
        <SectionHead
          eyebrow="Why Astalabista"
          title={
            <>
              Six reasons that are actually{" "}
              <span className="text-gradient">specific to us.</span>
            </>
          }
          lede="Not quality, not customer focus, not an experienced team. Those are table stakes claimed by everyone and verified by no one."
        />

        <div className="mt-10 grid overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] sm:mt-14 sm:grid-cols-2 lg:grid-cols-3">
          {DIFFERENTIATORS.map((d, i) => (
            <motion.div
              key={d.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.07 }}
              className="group relative border-b border-r border-white/[0.08] p-6 transition-colors duration-300 last:border-b-0 hover:bg-white/[0.03] sm:p-7"
            >
              <div className="font-mono text-[11px] tabular-nums text-white/25 transition-colors duration-300 group-hover:text-emerald-400/70">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-3 font-display text-base font-semibold tracking-tight text-white sm:text-lg">
                {d.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-white/60">{d.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </Section>
  );
}
